/* global hUrl */
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//   ####  ##      ##  ####    #####
//  ##     ##      ##  ##  ##  ##
//   ###   ##      ##  ##  ##  #####
//     ##  ##      ##  ##  ##  ##
//  ####   ######  ##  ####    #####

//  ###    ###  ##   ##
//  ## #  # ##  ##   ##
//  ##  ##  ##  ##   ##
//  ##      ##   ## ##
//  ##      ##    ###
if (document.getElementById('topMv')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('topMv')
  const sliderName = 'topMv'
  const topMvSwiper = new Swiper(slideItem, {
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 1500, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
    },
  })
}

//            ###    ###  #####  ##     ##  ##   ##
//            ## #  # ##  ##     ####   ##  ##   ##
//  ########  ##  ##  ##  #####  ##  ## ##  ##   ##
//            ##      ##  ##     ##    ###  ##   ##
//            ##      ##  #####  ##     ##   #####

let menuSlider = []
const menuSliderItem = document.getElementsByClassName('js-menuSlider')
if (menuSliderItem[0]) {
  for (const targetSlider of menuSliderItem) {
    const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
    menuSliderInit(targetSlider, sliderName)
  }
}
function menuSliderInit(targetSlider, sliderName) {
  menuSlider[sliderName] = new Swiper(targetSlider, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    slidesPerView: 1.3, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: 15, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      800: {
        slidesPerView: 1.5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        centeredSlides: true, // 中央のスライドを基準にする
      },
      1001: {
        slidesPerView: 4, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        centeredSlides: false, // 中央のスライドを基準にする
      },
    },
  })
}

if (document.getElementById('top-ir')) {
  topIr()
}

function topIr() {
  /*
           ###          ##    ###    ##     ##
         ##   ##        ##  ##   ##    ## ##
        ##     ##       ## ##     ##    ###
        ######### ##    ## #########   ## ##
        ##     ##  ######  ##     ## ##     ##
        */
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  /*
                ##        #######     ###    ########
                ##       ##     ##  ##   ##  ##     ##
        ####### ##       ##     ## ##     ## ##     ##
                ##       ##     ## ######### ##     ##
                ########  #######  ##     ## ########

        ページアクセス時にロードする
        <div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
        */
  const loadAjax = document.getElementById('top-ir')
  if (loadAjax) {
    const url = hUrl + 'ir/system/wp-admin/admin-ajax.php?action=founcdation_ir_pdf_list' // 取得先
    const to = loadAjax // 差し替え要素
    applyAjax(url, 'get', null, to, false)
  }

  /*
             ###    ########  ########  ##       ##    ##
           ##   ##  ##     ## ##     ## ##         ####
  ####### ##     ## ########  ########  ##          ##
          ######### ##        ##        ##          ##
          ##     ## ##        ##        ########    ##
  */
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, to, pushSt, flag = null) {
    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      if (pushSt === 'on') {
        history.pushState(null, null, url) // URL変更
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
        ajaxData = JSON.parse(ajaxData)
      }

      let html = ''
      for (const iterator of ajaxData) {
        html += `
<a id="news47837" name="news47837" href="${iterator['href']}" class="topNews__item" ${iterator['target_blank']}>
    <span class="topNews__date">
      ${iterator['post_date']}
    </span>
    <span class="topNews__cat">
      ${iterator['ir_type']}
    </span>
    <span class="topNews__title">
      <span class="topNews__cramp">
        ${iterator['title']}
      </span>
    </span>
</a>
        `
      }

      to.innerHTML = html
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
